import {createSlice, Dispatch, PayloadAction} from '@reduxjs/toolkit';

interface Links {
  key: string;
  links: Array<any>
}

const initialState: any = {
  'it-IT':[],
  'en-EN':[]
}

const sociSlice = createSlice({
  name: 'soci',
  initialState,
  reducers: {
    setInternalLinks(state, action: PayloadAction<Links>): void {
      const {payload} = action;
      state[payload.key] = payload.links;
    },
  }
});

const {
  setInternalLinks,
} = sociSlice.actions;

// Define a thunk that dispatches those action creators
export const getLinks = (key: string, links: Array<any>) => (dispatch: Dispatch) => {
  dispatch(setInternalLinks({key, links}));
}

export default sociSlice.reducer;
